import { useFormikContext } from "formik";
import { ReactElement } from "react";

import { FlexBox } from "~frontend/components/FlexBox";

import { TemplatePreview } from "./TemplatePreview";
import { CreateOrEditGifFormValues } from "./types";

export function FormGifPreview(): ReactElement {
  const form = useFormikContext<CreateOrEditGifFormValues>();

  if (!form.values.template) {
    return <></>;
  }

  return (
    <FlexBox justifyContent="center">
      <TemplatePreview
        template={form.values.template}
        customFields={form.values.customFields}
        customColors={form.values.customColors}
        logoUrl={form.values.logoUrl}
      />
    </FlexBox>
  );
}
